/**
 * Convert a string to an HTML Element
 * @param html HTML string to convert
 * @returns An HTML Element
 */
export const stringToElement = (htmlString: string) => {
  // Create an HTML template fragment to properly parse an HTML string
  const template = document.createElement('template')

  // Trim whitespace from the string if available
  // A regular string will parse as a TextNode
  template.innerHTML = htmlString ? htmlString.trim() : ''

  // Return the first genuine HTML element from the template
  return template.content.firstChild as Element
}
